import Vue from "vue";
import Raven from "raven-js";
import RavenVue from "raven-js/plugins/vue";

Raven.config("https://db75af1eb80f42688688635bd6f6f95f@sentry.io/1431980")
  .addPlugin(RavenVue, Vue)
  .install();
